import React from 'react'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { useTranslation } from 'react-i18next'

const Root = styled(Box)(({ theme: { palette, transitions, spacing } }) => ({
  display: 'flex',
  padding: spacing(2, 3),
  minWidth: '400px',
  cursor: 'pointer',
  transition: transitions.create('background-color', {
    easing: transitions.easing.easeInOut,
    duration: transitions.duration.shorter
  }),
  '&:hover': {
    backgroundColor: palette.grey[100]
  }
}))

type ManageVendorNavigationItemProps = {
  handleClose: () => void
  name: string
  id: string
}

const ManageVendorNavigationItem: React.FC<ManageVendorNavigationItemProps> = ({ handleClose, name, id }) => {
  const { t } = useTranslation()
  return (
    <Box
      sx={{ textDecoration: 'none', color: 'inherit' }}
      component={Link}
      to={`/vendors/manage/${id}/information`}
      onClick={handleClose}
    >
      <Root>
        <SettingsOutlinedIcon sx={{ mr: 2, color: 'primary.main' }} />
        <Box>
          <Typography>{name}</Typography>
          <Typography variant="body2" color="textSecondary">
            {t('edit-company-information')}
          </Typography>
        </Box>
      </Root>
    </Box>
  )
}

export default ManageVendorNavigationItem
